<template>
  <div>
    <vs-row class="catBgClr mx-4">
      <vs-row>
        <h3 class="p-5 pb-4">Add Point Groups</h3>
      </vs-row>
      <p class="pl-5 pb-6 pt-0 mb-2 whiteText">
        You may drag the fields to change the order
      </p>
      <vs-row>
        <div
          class="flex flex-wrap-reverse items-center ml-5 cursor mt-0 mb-5 pt-0"
          @click="addNewCategory"
        >
          <PlusSquareIcon color="white" />
          <h6 class="ml-2 mt-1 cursor">Add Category</h6>
        </div>
      </vs-row>
      <!--vs-row v-if="errors.categories.success">
      <p class="p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
    </vs-row-->

      <draggable v-model="point_categories" v-bind="dragOptions" class="w-full">
        <transition-group type="transition" name="flip-list">
          <vs-row
            :key="index"
            v-for="(category, index) in point_categories"
            class="ml-5 mb-5"
          >
            <vs-col vs-lg="7" vs-sm="6" class="pr-6" id="inputBorder">
              <vs-row>
                <vs-col class="mt-6" vs-lg="1">
                  <MenuIcon class="mt-6" />
                </vs-col>
                <vs-col vs-lg="11">
                  <div class="my-2 ml-4">
                    <vs-row>
                      <vs-col
                        vs-lg="5"
                        vs-sm="5"
                        class="inputContainer max-height-5-24"
                        vs-type="flex"
                        vs-justify="flex-start"
                      >
                        Category {{ index + 1 }}
                      </vs-col>
                      <vs-col
                        vs-lg="7"
                        vs-sm="7"
                        class="inputContainer max-height-5-24 pr-3"
                        vs-type="flex"
                        vs-justify="flex-end"
                      >
                        <vs-checkbox
                          v-model="point_categories[index].isHidden"
                          vs-name="isHidden"
                          :vs-value="true"
                          class=""
                          @click="isHiddenFunc()"
                        />
                        <div class="addCardFont font-semibold ml-0 mb-0">
                          Hide from Cheat Sheet
                        </div>
                      </vs-col>
                    </vs-row>
                  </div>
                  <vs-input
                    v-model="point_categories[index].name"
                    class="w-full p-3 pt-0 ml-1"
                    :disabled="point_categories.length == 0"
                  />
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="3" vs-type="flex" vs-justify="flex-start">
              <div
                v-if="
                  point_categories[index].isDeleteable ||
                  point_categories[index].isDeleteable == undefined
                "
                class="flex flex-wrap-reverse items-center cursor mt-1 pl-4"
                @click="removeCategory(index)"
              >
                <MinusSquareIcon color="white" class="mt-5" />
                <div
                  class="addCardFont font-semibold ml-3 cursor mt-6 whiteText"
                >
                  Remove
                </div>
              </div>

              <div
                v-if="point_categories[index].isDeleteable == false"
                class="cursor mt-2 pt-0 ml-1"
                style="opacity: 0.3"
              >
                <vx-tooltip
                  text="This category cannot be deleted since it is in use by cards"
                  position="top"
                >
                  <vs-row>
                    <MinusSquareIcon color="white" class="mt-5" />
                    <div
                      class="addCardFont font-semibold ml-3 cursor mt-6 whiteText"
                    >
                      Remove
                    </div>
                  </vs-row>
                </vx-tooltip>
              </div>
            </vs-col>
            <vs-col
              vs-lg="3"
              vs-sm="3"
              class="mt-10 pt-0"
              vs-justify="flex-start"
            >
              <vs-row class="">
                <vs-button
                  v-if="point_categories[index]._id != ''"
                  class="manageButton"
                  @click="toManage(category)"
                  >Manage Subcategories</vs-button
                >
              </vs-row>
            </vs-col>
          </vs-row>
        </transition-group>
      </draggable>
      <vs-row v-if="errors.categories.success">
        <p class="text p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
      </vs-row>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="updateStatus.status"
      >
        <h5>{{ updateStatus.msg }}</h5>
      </vs-popup>
    </vs-row>

    <vs-row class="mt-2 pr-10 pl-1" vs-justify="flex-end">
      <vs-button @click="updateCategories">Save</vs-button>
    </vs-row>
    <vs-popup
      class="holamundo"
      title="Status"
      :active.sync="NoCategory.status"
      @close="closefunc()"
    >
      <h5>{{ NoCategory.msg }}</h5>
    </vs-popup>
  </div>
</template>

<script>
import { PlusSquareIcon, MinusSquareIcon, MenuIcon } from "vue-feather-icons";
import draggable from "vuedraggable";
import { genericErrorMessage, toast } from "@/keys/toast-messages";

export default {
  components: {
    PlusSquareIcon,
    MinusSquareIcon,
    MenuIcon,
    draggable,
  },
  data() {
    return {
      point_categories: [],
      remove_categories: [],

      errors: {
        categories: {
          msg: "",
          success: false,
        },
        duplicateIndices: [],
      },

      updateStatus: {
        msg: "",
        status: false,
      },
      NoCategory: {
        msg: "",
        status: false,
      },
      genericErrorMessage,
      toast,
    };
  },
  methods: {
    scrollToBottomInput() {
      window.scrollTo(0, document.body.scrollHeight);
    },
    isHiddenFunc() {},
    async notempty() {
      for (var i = 0; i < this.point_categories.length; i++) {
        if (
          this.point_categories[i].name == "" ||
          !this.point_categories[i].name.trim()
        ) {
          this.errors.categories = {
            msg: "Please fill out all the categories fields",
            success: true,
          };
          return false;
        } else {
          this.errors.categories = {
            msg: "",
            success: false,
          };
        }
      }
      return true;
    },
    async removeCategory(index) {
      if (this.point_categories[index]._id) {
        await this.remove_categories.push(this.point_categories[index]._id);
      }
      this.point_categories.splice(index, 1);
      await this.notempty();
    },
    async addNewCategory() {
      if (await this.notempty()) {
        await this.point_categories.push({ _id: "", name: "" });
        this.point_categories = await this.point_categories.map(
          (value, index) => {
            return {
              name: value.name,
              _id: value._id,
              order: index + 1,
              isDeleteable: value.isDeleteable,
              isHidden: value.isHidden,
            };
          }
        );
      }
      this.scrollToBottomInput()
    },
    getCategories() {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve, reject) => {
        this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.PointCategories +  `?type=walletflo`)
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              resolve((this.point_categories = res.data.data));
              //console.log(this.point_categories);
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
            this.$vs.loading.close();
            // console.log("Error in getCategories: ",e);
          });
      });
    },
    async hasUniqueNames() {
      var tmpArr = [];
      for (var i = 0; i < this.point_categories.length; i++) {
        if (tmpArr.indexOf(this.point_categories[i].name) < 0) {
          tmpArr.push(this.point_categories[i].name);
        } else {
          // this.error.duplicateIndices.push(i);
          return false;
        }
      }
      // console.log('indices are: ',indices);
      return true;
    },
    async updateCategories() {
      //    this.hasUniqueNames(this.point_categories)
      if (await this.notempty()) {
        if (await this.hasUniqueNames(this.point_categories)) {
          this.errors.categories = {
            msg: "",
            success: false,
          };
          this.point_categories = await this.point_categories.map(
            (value, index) => {
              return {
                name: value.name,
                _id: value._id,
                order: index + 1,
                isHidden: value.isHidden ? value.isHidden : false,
              };
            }
          );
          let isAdded =
            this.point_categories.findIndex((element) => element._id == "") !=
            -1
              ? true
              : false;
          this.$vs.loading({
            background: "rgba(1,2,3,.2)",
          });
          return new Promise((resolve, reject) => {
            this.$axios
              .patch(
                this.$ApiKeys.BASE_URL + this.$EndPoints.PointCategories,
                {
                  pointCategories: this.point_categories,
                  removeCategories: this.remove_categories,
                  isAdded: isAdded,
                }
              )
              .then(async (res) => {
                const errors = res.data.response && res.data.response.errors ? res.data.response.errors : null
                this.$vs.loading.close();
                if (res.data.success) {
                  this.updateStatus = {
                    msg: res.data.message,
                    status: true,
                  };
                  resolve(this.getCategories());
                } else if (errors &&
                  Array.isArray(errors) &&
                  errors[0]
                ){
                  this.errors.categories = {
                    msg: errors[0],
                    success: true,
                  };
                }
                 else {
                  this.toast(this.genericErrorMessage());
                }
              })
              .catch((e) => {
                if (e.response.status !== 401) {
                  this.toast(this.genericErrorMessage());
                }
                this.$vs.loading.close();
                // console.log("Error in updateCategories: ",e);
              });
          });
        } else {
          this.errors.categories = {
            msg: "Point categories names must be unique.",
            success: true,
          };
        }
      }
    },
    async toManage(inp) {
      await this.$router.push({
        path: "/point-categories/subcategories/" + inp._id,
        // name: "subcategories",
        // params: {
        //   data: inp,
        // },
      });
    },
  },
  created() {
    this.getCategories();
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
};
</script>

<style>
#inputBorder {
  cursor: grab;
}
#inputBorder input {
  border-color: #1c1c1e !important;
}

.whiteText {
  color: white !important;
}
.con-vs-tooltip {
  margin-top: 20px;
  margin-left: 10px;
  /* padding-top: 20px; */
  /* background: green; */
}
.catBgClr {
  background-color: #1c1c1e;
  padding: 20px;
  border-radius: 10px;
}
.cursor {
  cursor: pointer;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
}
.manageButton {
  width: 207px;
  border-radius: 10, 21, 10, 21;
  font-size: 13px;
  height: 45px;
}
@media only screen and (min-width: 800px) {
  .text {
    margin-left: 70px;
    padding-left: 30px;
  }
}
@media only screen and (max-width: 800px) {
  .text {
    margin-left: 30px;
    padding-left: 10px;
  }
}
</style>

















//   async hasUniqueNames(){
//            let dupes = {};
//             await this.point_categories.forEach((item,index) => {
//                 dupes[item.name] = dupes[item.name] || [];
//                 dupes[item.name].push(index);
//             });
//             for (let key in dupes) {
//                 if(dupes[key].length > 1){
//                     // console.log(dupes[key]);
//                     dupes[key].forEach((item,index) => {
//                     // item.forEach((ele,i) => {
//                         // console.log('duplicate is: ',index);
//                         this.errors.duplicateIndices[item] = {
//                             msg: 'This category must be unique',
//                             success: false
//                         }  
//                     });   
//                 } 
//             // });   
//             }
                 

//             console.log('indices are: ',this.errors.duplicateIndices);
//             // return true;
//        },